module.exports = __webpack_public_path__ + "_rodapenov.png?b2a36ce4300db5e9f035bd63eb19ece8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/_rodapenov.png
// module id = 117
// module chunks = 0